import aboutphoto from '../assets/png/pic-1.jpeg';

export const aboutData = {
  title: 'LET ME INTRODUCE MYSELF',
  description: [
    {
      id: 1,
      desc: "💁My name is Hiren Dhadhal and I'm from Ahmedabad, Gujarat.",
    },
    {
      id: 2,
      desc: "I'm B.Tech graduate from Computer science department at NIT Surat [2023].🧑‍🎓",
    },
    {
      id: 3,
      desc: 'I have used HTML5, TailWind CSS, Javascript and ReactJS for building client side applications',
    },
    {
      id: 4,
      desc: '💡I have hands-on experience with server side technologies like NodeJS, Java [Springboot] and GoLang.',
    },
  ],
  image: aboutphoto,
};
